export const loader = () => {
  console.info('> Running the organization chart data loader');
  return {
    data: [],
  };
};
